import React from 'react'
import {ParagraphText, Button} from '@thryvlabs/maverick'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advanced from 'dayjs/plugin/advancedFormat'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advanced)

export const SchdulerSuccessComponent = ({
  scheduleCreativeCallDetails,
  scheduleKickOffCallDetails,
  accountInformation,
  handleModalClose,
}) => {
  const renderCallInfo = ({callType, callInfo}) => {
    return (
      <section
        style={{
          backgroundColor: 'white',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          padding: '20px',
          flex: 1,
        }}
      >
        <span className="row font-weight-bold pb-2 text-center">
          {callType}
        </span>
        <section className="d-flex gap-4">
          <section>
            <section className="row">
              <span>Time</span>
            </section>
            <section className="row">
              <span className="font-weight-bold">
                {dayjs(callInfo.thryvBookingDate)
                  .tz(callInfo.timeZone)
                  .format('h:mm a')}
                <br />
                {dayjs(callInfo.thryvBookingDate)
                  .tz(callInfo.timeZone)
                  .format('zzz')}
              </span>
            </section>
          </section>
          <section className="border-left-style ml-2 px-4">
            <section className="row">
              <span>Date</span>
            </section>
            <section className="row">
              <span className="font-weight-bold">
                {dayjs(callInfo.thryvBookingDate).format('dddd')}
                <br />
                {dayjs(callInfo.thryvBookingDate).format('MMMM D[,] YYYY')}
              </span>
            </section>
          </section>
        </section>
      </section>
    )
  }
  const renderBannerConfirmation = () => {
    return (
      <section
        style={{
          backgroundColor: 'white',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          padding: '20px',
          marginTop: '20px',
          textAlign: 'center',
        }}
      >
        <ParagraphText variant="reg" className="text-center">
          Your meeting has been scheduled
        </ParagraphText>
        <ParagraphText variant="reg" className="font-weight-bold text-center">
          {accountInformation.email}
        </ParagraphText>
      </section>
    )
  }
  return (
    <section
      style={{
        backgroundColor: '#F5F5F5',
        padding: '30px',
        borderRadius: '8px',
      }}
    >
      <section
        className={`d-flex ${
          scheduleCreativeCallDetails?.isCallScheduled &&
          scheduleKickOffCallDetails?.isCallScheduled
            ? 'justify-content-between'
            : 'justify-content-center'
        } gap-4`}
      >
        {scheduleKickOffCallDetails?.isCallScheduled &&
          renderCallInfo({
            callType: 'Marketing Center Kickoff Call',
            callInfo: scheduleKickOffCallDetails?.callDetails,
          })}
        {scheduleCreativeCallDetails?.isCallScheduled &&
          renderCallInfo({
            callType: 'Website Design Call',
            callInfo: scheduleCreativeCallDetails?.callDetails,
          })}
      </section>
      {renderBannerConfirmation()}
      <section className="d-flex justify-content-center mt-4">
        <Button
          variant="primary"
          onClick={() => {
            handleModalClose()
          }}
        >
          Continue
        </Button>
      </section>
    </section>
  )
}
